import * as React from 'react';
import { set } from "dot-prop-immutable";
import { Upload as DesignUpload, Modal, message } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';
import cloneDeep from "lodash/cloneDeep";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { ReactComponent as Add } from "@assets/icons/add.svg";

const UploadElement = (props) => {
  const messages = getLocale();
  
  const { updateElement, element, nameSpace, onChange, fileList=[] } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const {
    width = document.body.clientWidth / 2,
    height = document.body.clientHeight / 2 - 38.6,
    download,
    successMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT"],
    errorMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT"],
    failMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT"],
    ...restProps
  } = formItemSettings;
  const typeList = formItemSettings?.accept?.split(",") || [];
  const eventProps = makeEventProps(element.data.events, nameSpace);
  const { onChange: change = null, ...otherEventPros } = eventProps;
  const fileLists = [...fileList]

  const uploadButton = (
    <div>
      <Add />
      <div style={{ marginTop: 8 }}>{messages['PAGEBUIDER_ELEMENT_FORM_UPLOAD']}</div>
    </div>
  );
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const [previewImage, setPreviewImage] = React.useState()
  const [previewVisible, setPreviewVisible] = React.useState(false)
  const [previewTitle, setPreviewTitle] = React.useState()
  const handlePreview = async file => {
    if(file.url){
      setPreviewImage(file.url);
    }else{
      file.preview = await getBase64(file.originFileObj);
      setPreviewImage(file.preview);
    }
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
  };
  const handleCancel = () => setPreviewVisible(false);

  const handleChange = info => {
    let fileList = [...info.fileList];
    fileList = fileList.map(file => {
      if (file.status === 'done') {
        file.url = download.replace('${id}', file.response[0][formItemSettings.fileIdName]);
        file.thumbUrl = download.replace('${id}', file.response[0][formItemSettings.fileIdName]);
      } else {
        file.thumbUrl = file.thumbUrl || file.preview
      }
      return file;
    });
    if (info.file.status === 'done') {
      message.success(successMessage);
      const renderModel = (window.g_app._store.getState())[nameSpace] || {};
      if (!renderModel) {
        return false;
      }
      const { eventJs, form, childForm, fetch, macro } = renderModel;
      const ctx = {
        form,
        childForm,
        macro,
        fetch,
        events: eventJs
      };
      change && change(info, ctx);
    }
    if (info.file.status === 'error') {
      message.error(failMessage);
    }
    onChange(fileList)
    const newElement = set(element, 'data.formItemSettings.fileList', cloneDeep(fileList));
    updateElement({
      element: newElement,
    }, nameSpace);
  };

  //文件类型校验
  const checkType = (file, typeList) => {
    return new Promise(function (resolve, reject) {
      let res = false;
      if ((typeList.length === 0) || typeList.includes('*')) {
        res = true
      } else {
        typeList.forEach(type => {
          if (type === file.type) {
            res = true
          }
          if (type === 'image/*' && file.type.includes('image')) {
            res = true
          }
        });
      }
      if (res) {
        resolve()
      } else {
        message.error(errorMessage)
        reject()
      }
    })
  }

  return (
    <React.Fragment>
      <DesignUpload
        listType="picture-card"
        {...formItemSettings}
        download={download}
        beforeUpload={(file) => {
          return Promise.all([
            checkType(file, [...typeList]),
          ])
        }}
        fileList={fileLists}
        onChange={handleChange}
        onPreview={handlePreview}
        {...otherEventPros}
      >
        {uploadButton}
      </DesignUpload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={width}
        bodyStyle={{
          height,
        }}
      >
        <img alt="example" height={height - 32} style={{ maxWidth: `${width - 32}` }} src={previewImage} />
      </Modal>
    </React.Fragment>
  );
};

export default UploadElement;
